module.exports = __webpack_public_path__ + "img/直播场景_活动直播.2c01ac90.png";